module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "news"
    }
  }, [_c('heading', {
    attrs: {
      "text": _vm.$t('categories.news'),
      "level": 2,
      "font": "astonished",
      "color": "red"
    }
  }), _vm._v(" "), _c('list', {
    ref: "list",
    attrs: {
      "scroll": true,
      "items": _vm.news,
      "link": "news",
      "fields": ['title', 'date', 'author'],
      "type": "std"
    },
    on: {
      "update": _vm.load
    }
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66a25128"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/webzine/NewsFeed.vue
// module id = 264
// module chunks = 0